import { render, staticRenderFns } from "./doctorReport.vue?vue&type=template&id=2d11d8ff&scoped=true"
import script from "./doctorReport.vue?vue&type=script&lang=js"
export * from "./doctorReport.vue?vue&type=script&lang=js"
import style0 from "./doctorReport.vue?vue&type=style&index=0&id=2d11d8ff&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d11d8ff",
  null
  
)

export default component.exports